<template>
  <div class="noData" v-if="show">
    <img src="../../assets/img/noData.png" alt="">
    <p>File Not Found</p>
  </div>

</template>
<script>
import { imgURL } from '@/config/evn'
export default {
  data () {
    return {
      imgURL: imgURL,
      show: false
    }
  },
  mounted () {
    console.log(this.$route.params)
    this.getMediaLinkFn()
  },
  methods: {
    getMediaLinkFn () {
      let param = this.$route.params
      this.$Post(this.$api.getMediaLink, {...param, timestamp:new Date().getTime()})
        .then(res => {
          if (res.code === '0') {
            let url = encodeURI(res.datas.url).replace('+', '%2B').replace('@', '%40')
            console.log(url)
            if (url.includes('http')) {
              window.open(`${url}`, '_self')
            } else {
              window.open(`${this.imgURL}${url}`, '_self')
            }
          }else if(res.code==='-1'){
            this.show = true
          }
        })
    },
  },

}
</script>

<style lang="less" scoped>
.noData {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  transform: translate(0, 50%);
  height: 340px;
  img {
    width: 384px;
    height: 298px;
  }
  p{
    font-size: 22px;
    font-weight: 600;
    margin: 10px 0px 0px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/media/index.vue